class GeneralDeliveryCountdown extends HTMLElement {
  constructor() {
    super();
    this.deliveryTime = this.dataset.dailyTime;
    this.deliveryTimeMins = this.dataset.dailyTimeMinutes;
    this.saturdayCutOffTime = this.dataset.saturdayTime;
    this.saturdayCutOffTimeMins = this.dataset.saturdayTimeMinutes;
    this.saturdayDelivery = this.dataset.saturdaysDelivery === 'true';
    this.sundayCutOffTime = this.dataset.sundayTime;
    this.sundayCutOffTimeMins = this.dataset.sundayTimeMinutes;
    this.sundayDelivery = this.dataset.sundaysDelivery === 'true';
    this.blockedGeneralDaysArray = this.dataset.blockedGeneralDates ? this.dataset.blockedGeneralDates.split(',') : [];
    this.messageBeforeCutOff = this.dataset.messageBeforeCutOff;
    this.messageAfterCountdown = this.dataset.messageAfterCountdown;
    this.messageAfterCutOff = this.dataset.messageAfterCutOff;
    this.blockedDaysArray = [];
    this.setBlockedDays();
  }

  connectedCallback() {
    this.message = this.querySelector('.message');
    this.messageAfter = this.querySelector('.message-after');
    this.timer = this.querySelector('.timer');
    if (!this.message || !this.timer) return;
    this.checkForDeliveryMessage();
  }

  setBlockedDays() {
    this.blockedGeneralDaysArray = this.dataset.blockedGeneralDates ? this.dataset.blockedGeneralDates.split(',') : [];
  }

  getDaySuffix(dayNumber) {
    if (dayNumber === 1 || dayNumber === 21 || dayNumber === 31) {
      return 'st';
    } else if (dayNumber === 2 || dayNumber === 22) {
      return 'nd';
    } else if (dayNumber === 3 || dayNumber === 23) {
      return 'rd';
    }
    return 'th';
  }

  checkForDeliveryMessage() {
    const now = new Date();
    let deliveryTime = Number(this.deliveryTime);
    let deliveryTimeMins = Number(this.deliveryTimeMins);
    const day = now.getDay();

    // Check if today is Saturday or Sunday
    if (day === 6) {
      deliveryTime = Number(this.saturdayCutOffTime);
      deliveryTimeMins = Number(this.saturdayCutOffTimeMins);
    } else if (day === 0) {
      deliveryTime = Number(this.sundayCutOffTime);
      deliveryTimeMins = Number(this.sundayCutOffTimeMins);
    }

    if (deliveryTimeMins === 0) {
      deliveryTimeMins = '00';
    }

    const jan = new Date(now.getFullYear(), 0, 1);
    const jul = new Date(now.getFullYear(), 6, 1);
    const dst = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset()) - now.getTimezoneOffset();
    deliveryTime -= Math.floor(dst / 60);

    const endString = `${now.toISOString().split("T")[0]}T${deliveryTime}:${deliveryTimeMins}:00Z`;
    const end = new Date(endString);
    const diff = end - now;

    let missedTodayDelivery = diff <= 0;

    if ((day === 6 && !this.saturdayDelivery) || (day === 0 && !this.sundayDelivery)) {
      missedTodayDelivery = true;
    }

    if (missedTodayDelivery) {
      this.showMessageNoCountdown(day);
    } else {
      this.message.innerHTML = this.messageBeforeCutOff;
      if (this.messageAfterCountdown === '') {
        this.messageAfter.style.display = 'none';
      } else {
        this.messageAfter.innerHTML = this.messageAfterCountdown;
      }
      this.startCountdown(endString);
    }
  }

  showMessageNoCountdown(day) {
    this.message.innerHTML = this.messageAfterCutOff;
    this.messageAfter.style.display = 'none';
    this.findNextDayDelivery();
  }

  findNextDayDelivery() {
    const now = new Date();
    let nextDelivery = new Date(now);
    const blockedDaysFormatted = this.blockedDaysArray.map(date => new Date(date).toISOString().split('T')[0]);
    const blockedGeneralDaysFormatted = this.blockedGeneralDaysArray.map(date => new Date(date).toISOString().split('T')[0]);

    let deliveryTime = Number(this.deliveryTime);
    let deliveryTimeMins = Number(this.deliveryTimeMins);
    // Check if today is Saturday or Sunday
    if (now.getDay() === 6) {
      deliveryTime = Number(this.saturdayCutOffTime);
      deliveryTimeMins = Number(this.saturdayCutOffTimeMins);
    } else if (now.getDay() === 0) {
      deliveryTime = Number(this.sundayCutOffTime);
      deliveryTimeMins = Number(this.sundayCutOffTimeMins);
    }

    // Check if the cutoff time has already passed
    const cutoffTime = new Date(now);
    cutoffTime.setHours(deliveryTime, deliveryTimeMins, 0, 0);
    
    if (now.getDay() === 0){
      nextDelivery.setDate(nextDelivery.getDate() + 2);
    } else {
      if (now > cutoffTime) {
        nextDelivery.setDate(nextDelivery.getDate() + 2);
        if (now.getDay() === 6) {
          nextDelivery.setDate(nextDelivery.getDate() + 1);
        }
      } else {
        nextDelivery.setDate(nextDelivery.getDate() + 1);
      }
    }

    let nextDeliveryFormatted;
    do {
      nextDeliveryFormatted = nextDelivery.toISOString().split('T')[0];
      if (
        blockedDaysFormatted.includes(nextDeliveryFormatted) ||
        blockedGeneralDaysFormatted.includes(nextDeliveryFormatted)
      ) {
        nextDelivery.setDate(nextDelivery.getDate() + 1);
      }
    } while (
      blockedDaysFormatted.includes(nextDeliveryFormatted) ||
      blockedGeneralDaysFormatted.includes(nextDeliveryFormatted)
      );

    this.timer.innerHTML = this.displayDayName(nextDelivery);
  }

  displayDayName(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = days[date.getDay()];
    const dayNumber = date.getDate();
    const suffix = this.getDaySuffix(dayNumber);

    return `${dayName} ${dayNumber}${suffix}`;
  }

  startCountdown(endDateUTC) {
    const intervalId = setInterval(() => {
      const now = new Date();
      const end = new Date(endDateUTC);
      const diff = end - now;

      if (diff <= 0) {
        clearInterval(intervalId);
        this.showMessageNoCountdown(now.getDay());
        return;
      }

      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.timer.innerHTML = `${hours > 0 ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
    }, 1000);
  }
}

customElements.define('lq-general-delivery-countdown', GeneralDeliveryCountdown);

class DeliveryCountdown extends GeneralDeliveryCountdown {
  constructor() {
    super();
    super.setBlockedDays();
    this.blockedDaysArray = this.dataset.blockedDates ? this.dataset.blockedDates.split(',') : [];
  }
}
customElements.define('lq-delivery-countdown', DeliveryCountdown);
